export default __webpack_public_path__ + "static/media/fail_all.cf9dcc4d.svg";